module.exports = __webpack_public_path__ + "static/media/fastsport.97406e9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/fastsport.jpg
// module id = 2395
// module chunks = 7